import { Button, Tooltip, TooltipContent, TooltipTrigger } from '@folio/components';
import { cn } from '@folio/lib';
import { Archive, ArchiveRestore } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { REVEALED_ON_HOVER } from './threadHelpers';

export function ArchiveButton({
  scope,
  isArchived,
  onClick,
  className,
}: {
  scope: 'thread' | 'email';
  isArchived: boolean;
  onClick: () => void;
  className?: string;
}) {
  const { t } = useTranslation();
  const label = t(`generalInbox.archive.${scope}.${isArchived ? 'unarchive' : 'archive'}`);
  const Icon = isArchived ? ArchiveRestore : Archive;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className={cn('size-7', REVEALED_ON_HOVER, className)}
          aria-label={label}
          data-testid={`general-inbox-archive-${scope}`}
          onClick={onClick}
        >
          <Icon className="size-4" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
}
